export const Chips = ({ items, value, onChange, testid }) => {
  const toggle = (x) => onChange(value.includes(x) ? value.filter((v) => v !== x) : [...value, x]);
  return (
    <div className="flex flex-wrap gap-2 mt-2" data-testid={testid}>
      {items.map((x, i) => {
        const on = value.includes(x);
        return (
          <button type="button" key={x} onClick={() => toggle(x)} aria-pressed={on} data-testid={`${testid}-${i}`}
            className={`px-3 py-1.5 text-xs border transition-colors ${on ? "bg-[#5E9420] border-[#5E9420] text-white" : "bg-white border-[#DADADA] hover:border-[#5E9420]"}`}>
            {x}
          </button>
        );
      })}
    </div>
  );
};

export const Field = ({ label, children, className = "" }) => (
  <label className={`block text-xs text-[#575757] ${className}`}>{label}{children}</label>
);
